// src/components/Popup/index.jsx
import React, {useEffect, useState} from 'react';
import popupStore from "../../../store/popupStore";
import Popup from "./index";
import Button from "../Button";
import {VARIANT} from "../../../constants";
import addressStore from "../../../store/addressStore";
import appStore from "../../../store/appStore";
import {isEmpty} from "lodash";

const PopupComponent = () => {
  const {isOpen, data, setPopup} = popupStore() || {}
  const {
    title,
    desc,
    image,
    accept,
    cancel,
    autoAccept,
    customContent,
    classImage,
    btnCancelNew,
    bgClass,
    customTitle,
    buttonCloseClass,
    isHideButtonClose
  } = data || {};
  const {detailAddress, setDetailAddress} = addressStore();
  const {addressChoice, setAddressChoice} = appStore()
  const [count, setCount] = useState(autoAccept);

  useEffect(() => {
    setCount(autoAccept)
  }, [autoAccept]);


  useEffect(() => {
    if (autoAccept > 0) {
      const timer = setTimeout(() => {
        if (count <= 0) {
          accept?.action();
          setPopup({})
        }
        setCount(count - 1)
      }, 1000);
      return () => clearTimeout(timer)
    }
  }, [autoAccept, count]);

  const handleClose = () => {
    if (!isEmpty(detailAddress)) setDetailAddress({})
    if (!isEmpty(addressChoice)) setAddressChoice(null)
    setPopup({})
  }
  if (!isOpen) return null;

  return (
    <Popup bgClass={bgClass} isOpen={isOpen} buttonCloseClass={buttonCloseClass} onClose={handleClose}
           isHideButtonClose={isHideButtonClose}>
      {
        customContent ? customContent() : (
          <div className='flex text-center flex-col gap-5 py-5 bg-white justify-center items-center w-80'>
            {title && <p className='text-base font-bold'>{title}</p>}
            {image && <img src={image} className={classImage || ''} alt="image-popup"/>}
            {desc && <p className='text-[#9E9E9E] text-xs'>{desc}
              {count > 0 && <span className='text-[#9E9E9E] text-xs'>{` (${count}s)`}</span>}
            </p>}
            {customTitle &&
              <div className='text-sm text-[#9E9E9E]' dangerouslySetInnerHTML={{__html: customTitle}}/>}
            <Button className='w-full' variant={VARIANT.PRIMARY} onClick={accept?.action || (() => {
            })}>
              {accept?.label || ''}
            </Button>
            {
              btnCancelNew && (
                <Button
                  className='w-fit bg-transparent text-[#197D55] underline hover:border-none text-sm'
                  onClick={btnCancelNew?.action || (() => {
                  })}>
                  {btnCancelNew?.label || ''}
                </Button>
              )
            }
            {
              cancel &&
              (
                <Button className='w-full' variant={VARIANT.SECONDARY}
                        onClick={cancel?.action || (() => {
                        })}>
                  {cancel?.label || ''}
                </Button>
              )
            }
          </div>
        )
      }
    </Popup>
  );
};

export default PopupComponent;
